import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=5a568fb7&scoped=true"
import script from "./afterSale.vue?vue&type=script&lang=js"
export * from "./afterSale.vue?vue&type=script&lang=js"
import style0 from "./afterSale.vue?vue&type=style&index=0&id=5a568fb7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a568fb7",
  null
  
)

export default component.exports